import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import auth from "./modules/auth";
import sensors from "./modules/sensors";
import dashboard from "./modules/dashboard";
import dateTime from "./modules/date-time";
import reports from "./modules/reports";
import profile from "./modules/profile";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user,
    auth,
    sensors,
    dashboard,
    dateTime,
    reports,
    profile
  },
  strict: debug
});